import { memo } from "react";
import Button from "@mui/material/Button";
import { getBackofficePath } from "util/general";
import { BackOffice } from "consts/general";
import { PRE_APPLICATION_PATH } from "consts/onboarding";

const AddMerchantManually = () => (
    <Button
        variant='contained'
        href={`//${getBackofficePath(BackOffice.Merchants, PRE_APPLICATION_PATH).toLowerCase()}`}
    >
        Add Merchant Application Manually
    </Button>
);

export default memo(AddMerchantManually);
